import { useEffect } from "react";
import Nav from "../components/site/Nav";
import Hero from "../components/site/Hero";
import Manifesto from "../components/site/Manifesto";
import Services from "../components/site/Services";
import Process from "../components/site/Process";
import Portfolio from "../components/site/Portfolio";
import Testimonials from "../components/site/Testimonials";
import Pricing from "../components/site/Pricing";
import FAQ from "../components/site/FAQ";
import Contact from "../components/site/Contact";
import Footer from "../components/site/Footer";
import useReveal from "../hooks/useReveal";
import { useT } from "../i18n/LanguageContext";

const SITE_URL = "https://gfirem.com";

export default function Home() {
    useReveal();
    const { t, lang } = useT();

    useEffect(() => {
        document.title = t("meta.title");
    }, [t, lang]);

    // Runtime FAQPage JSON-LD generated from whichever language dictionary is active,
    // so the schema entity stays in sync with the on-page FAQ copy (EN or ES).
    useEffect(() => {
        const items = t("faq.items");
        if (!Array.isArray(items) || items.length === 0) return;
        const scriptId = "faq-jsonld";
        let script = document.getElementById(scriptId);
        if (!script) {
            script = document.createElement("script");
            script.type = "application/ld+json";
            script.id = scriptId;
            document.head.appendChild(script);
        }
        const jsonld = {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "@id": `${SITE_URL}/#faq`,
            inLanguage: lang === "es" ? "es-LA" : "en-US",
            mainEntity: items.map((entry) => ({
                "@type": "Question",
                name: entry.q,
                acceptedAnswer: { "@type": "Answer", text: entry.a },
            })),
        };
        script.textContent = JSON.stringify(jsonld);
        return () => {
            const s = document.getElementById(scriptId);
            if (s && s.parentNode) s.parentNode.removeChild(s);
        };
    }, [t, lang]);

    return (
        <main data-testid="home-page" className="bg-sand text-ink">
            <div className="fixed top-0 left-0 right-0 z-50">
                <Nav />
            </div>
            <Hero />
            <Manifesto />
            <Services />
            <Process />
            <Portfolio />
            <Testimonials />
            <Pricing />
            <FAQ />
            <Contact />
            <Footer />
        </main>
    );
}
